<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" @close="closed" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="rules" ref="dataForm"   @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <div class="line-box">
        <!-- <el-form-item  label="媒体" prop="media">
          <el-select v-model="dataForm.media" filterable clearable placeholder="请选择渠道">
            <el-option
                    v-for="item in channels"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> -->

      <el-form-item v-show="!dataForm.id" label="项目" class="styW" prop="project">
        <el-select v-model="dataForm.project" @change="getName()" class="hundred" filterable clearable placeholder="请选择公司">
                  <el-option
                          v-for="item in projectList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
      </el-form-item>
    
      <el-form-item  v-if="isDetail && !dataForm.id" label="明细"  prop="detail" class="styW">
              <el-select v-model="dataForm.detail" @change="getName()" class="hundred" filterable clearable placeholder="请选择">
                  <el-option
                          v-for="item in detailList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
      </el-form-item>
      <el-form-item v-show="!dataForm.id" label="视屏种类" class="styW" prop="type">
              <el-select v-model="dataForm.type" @change="getName()" class="hundred" filterable clearable placeholder="请选择">
                  <el-option
                          v-for="item in viewTypeList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
      </el-form-item>
      <el-form-item v-show="!dataForm.id" label="名称说明" class="styW" prop="nameIntroduce">
              <el-select v-model="dataForm.nameIntroduce" @change="getName()" class="hundred" filterable clearable placeholder="请选择">
                  <el-option
                          v-for="item in nameIntroduceList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
      </el-form-item>
    
      <el-form-item v-show="!dataForm.id" label="备注" prop="remark" class="styW"  >
          <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
      </div>
      <el-form-item label="名称全称" prop="fullName">
        {{ dataForm.fullName }}
      </el-form-item>
      <el-form-item label="更新说明" v-if="dataForm.id">
        	只对视频内容更新，文件名不变。
      </el-form-item>
      <el-form-item >
        <video-upload ref="video" :isid="dataForm.id"></video-upload>
      </el-form-item>
      </el-form>
    <template slot="footer">
      
      <el-button @click="cancel">{{ $t('cancel') }}</el-button>
      <el-button type="primary" :loading="upLoading" @click="dataFormSubmitHandle()">{{upLoading ? '视频上传中' : '确定' }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import videoUpload from '../../../components/video-upload.vue'
export default {
  data () {
    return {
      citys: [],
      companys: [],
      projectList: [],
      detailList: [],
      viewTypeList: [],
      nameIntroduceList: [],
      upLoading:false,
      visible: false,
      fileList: [], 
      loading:true, 
      vnum: 0,
      dataForm: {
        project: '',
        nameIntroduce: '',
        type: '',
        detail: '',
        remark:'',
        fullName:'',
        // media: '',
            },
      channels: [],
      fd: null,
      fd1: null,
      rules: {
        project: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
        ],
        detail: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        nameIntroduce: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        type: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
      }
      
    }
  },
  mounted(){
   
  },
  computed: {
    isDetail(){
      if(this.dataForm.project == '1' || this.dataForm.project == '2' ){
        if(!this.dataForm.id){
          return true
        }
        
      }
    },
  },

  methods: {
   
    cancel(){
      this.$refs.video.fileList = []
      this.$emit('refreshDataList')
      this.visible = false
    },
    getName(){
     if(this.dataForm.project && this.dataForm.nameIntroduce && this.dataForm.type){
       let project = this.projectList.filter(item => item.value == this.dataForm.project)[0].label
       let nameIntroduce = this.nameIntroduceList.filter(item => item.value == this.dataForm.nameIntroduce)[0].label
       let detail = ''
       let viewType = this.viewTypeList.filter(item => item.value == this.dataForm.type)[0].label
       if(this.dataForm.project == '1' || this.dataForm.project == '2'){
         detail = this.detailList.filter(item => item.value == this.dataForm.detail)[0].label
       }else{
         detail = ''
       }
       this.dataForm.fullName = this.getNowDate() + `${nameIntroduce}(${ project})${detail ? '-' + detail : ''}-${viewType}-字节`
     }
   
   },
    closed(){
      this.$refs.video.$refs.video.value = null
      this.$emit('refreshDataList')
      this.$refs.video.fileList = []
    },
    getNowDate() {
      const timeOne = new Date()
      const year = timeOne.getFullYear()
      let month = timeOne.getMonth() + 1
      let day = timeOne.getDate()
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      const NOW_MONTHS_AGO = `${year}${month}${day}`
      return NOW_MONTHS_AGO
    },

    init () {
        this.getProject();
        this.getNameIntroduce();
        this.getdetail()
        this.getviewtype()
        this.getchannelsOptions()
        // this.$loading({
        //   target:document.querySelector('.loading'),
        //   lock: true,
        //   text: 'Loading',
        //   spinner: 'el-icon-loading',
        //   background: 'rgba(0, 0, 0, 0.7)'
        // })
        this.visible = true
        this.$nextTick(() => {
       
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.id) {
        
            this.getInfo()
        }
      })
    },
      //初始化渠道下拉框中的选项
      async getchannelsOptions() {
      this.$http.get(`/sys/channels/list`).then(({data: res}) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.channels = [];
        if (res.data != null) {
          res.data.forEach(element => {
            if(element.id == '12' || element.id == '10' || element.id == '15') this.channels.push({label: element.name, value: element.id});
            
          })
        }
      })
    },
      //初始化项目
      async getProject() {
              this.$http.get(`/sys/dict/data/list?dataType=project`).then(({ data: res }) => {
                  if (res.code !== 0) {
                      return this.$message.error(res.msg)
                  }
                  this.projectList=[];
                  if (res.data!=null){
                      res.data.forEach(element => {
                          this.projectList.push({label:element.dictLabel,value:element.dictValue})
                      })
                 
               
                  }
              }).catch(() => {})
      },
        //初始化项目
        async getdetail() {
              this.$http.get(`/sys/dict/data/list?dataType=detail`).then(({ data: res }) => {
              
                  if (res.code !== 0) {
                      return this.$message.error(res.msg)
                  }
                  this.detailList=[];
                  if (res.data!=null){
                      res.data.forEach(element => {
                          this.detailList.push({label:element.dictLabel,value:element.dictValue})
                      })
                
               
                  }
              }).catch(() => {})
      },
       //初始化项目
       async getviewtype() {
              this.$http.get(`/sys/dict/data/list?dataType=view_type`).then(({ data: res }) => {
             
                  if (res.code !== 0) {
                      return this.$message.error(res.msg)
                  }
                  this.viewTypeList=[];
                  if (res.data!=null){
                      res.data.forEach(element => {
                          this.viewTypeList.push({label:element.dictLabel,value:element.dictValue})
                      })
                
               
                  }
              }).catch(() => {})
      },
       //初始化项目
      async getNameIntroduce() {
              this.$http.get(`/sys/dict/data/list?dataType=name_introduce`).then(({ data: res }) => {
               
                  if (res.code !== 0) {
                      return this.$message.error(res.msg)
                  }
                  this.nameIntroduceList=[];
                  if (res.data!=null){
                      res.data.forEach(element => {
                          this.nameIntroduceList.push({label:element.dictLabel,value:element.dictValue})
                      })
              
               
                  }
              }).catch(() => {})
      },
   
   
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/videouploadinfo/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
      
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
     
      }).catch(() => {})
    },
    requestVidio(fd,index){
      // debugger
      console.log(index,'index')
      
      if(index == this.$refs.video.fileList.length && !this.dataForm.id){
        this.vnum = 0
        return;
      } 
      if(!fd){
          fd = new FormData()
          fd.append('file',this.$refs.video.fileList[index].file)
          fd.append('body',JSON.stringify(this.dataForm))
      }

      this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/videouploadinfo', fd).then(({ data: res }) => {
          
          if (res.code !== 0) {
            this.$set(this.$refs.video.fileList , index , {...this.$refs.video.fileList[index],isupload: 1})
            return this.$message.error(res.msg)
          }
          this.$set(this.$refs.video.fileList , index , {...this.$refs.video.fileList[index],isupload: 2})
          // this.$refs.video.fileList = []
          this.$refs.video.$refs.video.value = null
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 2000,
            onClose: () => {
              if(this.dataForm.id){
                this.upLoading = false
                this.visible = false
                this.$emit('refreshDataList')
              }
            }
          })
          // if(this.dataForm.id){
          //   this.$message({
          //   message: this.$t('prompt.success'),
          //   type: 'success',
          //   duration: 2000,
          //   onClose: () => {
          //     this.visible = false
          //     this.$emit('refreshDataList')
          //   }
          // })
          // }else{
          //     this.$message({
          //     message: `成功存储${res.data.uploadedSuccessfully}个,重复${res.data.uploadFailed}个`,
          //     type: 'success',
          //     duration: 2000,
          //     onClose: () => {
          //       this.visible = false
          //       this.$emit('refreshDataList')
          //     }
          //   })
          // }
         
        }).catch(() => {
          console.log('catch',index)
          this.$set(this.$refs.video.fileList , index , {...this.$refs.video.fileList[index],isupload: 1})
        }).finally((v)=>{
          if(this.dataForm.id) return;
          let istrue = true
          this.$refs.video.fileList.forEach(item => {
            console.log(item)
            if(item.isupload == 0){
              istrue = false
            }
          })
        
         setTimeout(()=>{
          this.requestVidio('', ++this.vnum)
         },2000)
         
          if(istrue){
            this.visible = false
            this.upLoading = false
            this.$emit('refreshDataList')
          } 
          
        })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.upLoading = true
        this.$refs.video.fileList.forEach((v,index) => {
           this.$set(this.$refs.video.fileList , index , {...this.$refs.video.fileList[index],isupload: 0})
       })
        
        this.fd = new FormData()
        if(!this.$refs.video.fileList.length > 0){
          this.$message.error('请选择视屏文件')
          return
        }
       
        let fileObj = this.$refs.video.fileList[this.$refs.video.fileList.length-1] ? this.$refs.video.fileList[this.$refs.video.fileList.length-1] : this.$refs.video.fileList[this.$refs.video.fileList.length-1].File
        // this.fd.append('file',fileObj)
        
        if(this.dataForm.id){
          this.fd.append('id',this.dataForm.id)
          this.fd.append('file',fileObj.file)
          this.requestVidio(this.fd)
        }else{
          this.fd.append('body',JSON.stringify(this.dataForm))
          //   this.$refs.video.fileList.forEach((item , index) => {
          //   this.fd1 = new FormData()
          //   this.fd1.append('file',item.file)
          //   this.fd1.append('body',JSON.stringify(this.dataForm))
          //   this.requestVidio(this.fd1 ,index)
          // })
          this.requestVidio('' ,this.vnum)

        }
       
      })
    }, 1000, { 'leading': true, 'trailing': false })
  },
  components:{
    videoUpload,
  }
}
</script>

<style scoped >
.vi{
 
}

.video{
  
 display: none;
}

</style>
